<template>
  <div class="sourceRecordThread">
    <div>
      <li
        style="display: block;color: #000000;font-family: dfyuanstd-w5, dfyuanstd-w3;font-size: 1rem;"
      >
        生產重量
      </li>
      <div class="d-flex justify-content-start" style="margin-bottom: 4px;">
        <span class="my-auto">單支重(G)：</span>
        <input
          type="number"
          min="0"
          step="0.01"
          @blur="checkChangeInput('unit_actual_weight')"
          v-model="sourceData[userSelectCode].unit_actual_weight"
          :disabled="!modStatus"
          class="text-center"
          :class="{
            'sourceRecord-input-disabled': !modStatus
          }"
          style="width: 75px;"
        />
      </div>
      <commonRuncardTable
        :workID="workID"
        :runcardItem="sourceData[userSelectCode].runcardItem"
        :reason="sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
    <div>
      <li
        style="display: block;color: #000000;font-family: dfyuanstd-w5, dfyuanstd-w3;font-size: 1rem;"
      >
        總生產時間
      </li>
      <commonTotalProduceTable
        :processID="processID"
        :totalProduceTimeItem="sourceData[userSelectCode].totalProduceTimeItem"
        :reason="sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
  </div>
</template>

<script>
import commonRuncardTable from "@/components/orderManagement/table/commonRuncardTable.vue";
import commonTotalProduceTable from "@/components/orderManagement/table/commonTotalProduceTable.vue";
import { mapActions } from "vuex";
export default {
  name: "sourceRecordThread",
  props: {
    userSelectCode: {
      type: Number,
      default: 0
    },
    workID: {
      type: String
    },
    processID: {
      type: String
    },
    sourceData: {
      type: Array,
      default: [
        {
          unit_actual_weight: "",
          runcardItem: [],
          totalProduceTimeItem: [],
          reason: []
        }
      ]
    },
    modStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // userSelectCode: 0
    };
  },
  created: function() {},
  mounted: function() {},
  components: {
    commonRuncardTable,
    commonTotalProduceTable
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal"
    }),
    checkChangeInput(position, index = null) {
      let vm = this;
      switch (position) {
        case "unit_actual_weight":
          console.log("unit_actual_weight");
          let unit_actual_weight =
            vm.sourceData[vm.userSelectCode].unit_actual_weight;
          if (
            unit_actual_weight < 0 ||
            unit_actual_weight == "" ||
            isNaN(unit_actual_weight)
          ) {
            vm.sourceData[vm.userSelectCode].unit_actual_weight =
              vm.sourceData[vm.userSelectCode].orgUnit_actual_weight;
            vm.set_alertMsg(`單支重僅能是正數，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }

          let std_sgl_weight = vm.sourceData[vm.userSelectCode].std_sgl_weight;
          let unit_range = [
            Number((std_sgl_weight * 0.9).toFixed(2)),
            Number((std_sgl_weight * 1.1).toFixed(2))
          ];
          console.log(unit_range);
          if (
            unit_range[0] > unit_actual_weight ||
            unit_actual_weight > unit_range[1]
          ) {
            vm.sourceData[vm.userSelectCode].unit_actual_weight =
              vm.sourceData[vm.userSelectCode].orgUnit_actual_weight;
            vm.set_alertMsg(
              `單支重須符合標準重量:${unit_range[0]}~${unit_range[1]}，請再次確認`
            );
            vm.settimeout_alertModal();
            return;
          }

          vm.sourceData[
            vm.userSelectCode
          ].orgUnit_actual_weight = unit_actual_weight;
          var queryIndex = vm.sourceData[vm.userSelectCode].reason.indexOf(
            "unit_actual_weight"
          );
          if (
            vm.sourceData[vm.userSelectCode].in_unit_actual_weight !=
            unit_actual_weight
          ) {
            if (queryIndex == -1) {
              vm.sourceData[vm.userSelectCode].reason.push(
                "unit_actual_weight"
              );
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              vm.sourceData[vm.userSelectCode].reason.splice(queryIndex, 1);
            }
          }
          break;

        default:
          break;
      }
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/orderManagement/sourceRecord/sourceRecordThread.vue